<div>
    @if (success) {
        <div class="content">
            <div class="logo">
                <ui-logo [small]="true"></ui-logo>
            </div>
            <div class="title">
                <h1>Password Connection Works</h1>
            </div>
            <div class="text">
                <p>The tested password connection works with the Bannerflow platform!</p>
            </div>
        </div>
    }
</div>
